import React from "react";
import { PrimaryLinkStyle as Link } from "./BaseLink";
import { Arrow } from "../../BaseComponents/Icons/Svg";
import { useGlobal } from "reactn";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import styled from "styled-components";

const LinkWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`;
export const BlockLink = (props) => {
	const [theme] = useGlobal("theme");
	const { text, ...rest } = props;
	return (
		<LinkWrapper>
			<Link
				fontWeight="500"
				margin="1.5rem 0 0.5rem 0"
				fontSize="20px"
				display="flex"
				alignItems="center"
				justifyContent="flex-end"
				{...rest}
			>
				<span>{text}</span>
				<Arrow
					margin="0 0 0 6px"
					color={props.color ? props.color : theme.colors.primary}
				/>
			</Link>
		</LinkWrapper>
	);
};
